import { PbhRemoveReasonType } from "./PbhRemoveReasonType";
import { RbhRemoveReasonType } from "./RbhRemoveReasonType";

export enum ScheduledRemoveReasonSubType {
  None = 0,
  LLP = 1,
  Modification = 2,
  TBO = 3,
  TBR = 4,
}

export enum UnscheduledRemoveReasonSubType {
  None = 0,
  FailOnFit = 1,
  INOP = 2,
  PhysicalDamage = 3,
  PrematureFailure = 4,
}

export enum RejectionQuarantinedRemoveReasonSubType {
  None = 0,
  PartReceivedAsDamaged = 1,
  TypoMistakeInDocumentation = 2,
  TsnCsnIssue = 3,
  MissingPageInPaperwork = 4,
  AdSbIssue = 5,
  PnSnMismatcDiscrepancy = 6,
  LifeOfThePartAboutToExpire = 7,
  Other = 8,
}

export const GetScheduledRemoveReasonSubType = [
  // { Description: "None", Value: ScheduledRemoveReasonSubType.None },
  { Description: "LLP", Value: ScheduledRemoveReasonSubType.LLP },
  { Description: "Modification", Value: ScheduledRemoveReasonSubType.Modification },
  { Description: "TBO", Value: ScheduledRemoveReasonSubType.TBO },
  { Description: "TBR", Value: ScheduledRemoveReasonSubType.TBR },
];

export const GetUnscheduledRemoveReasonSubType = [
  // { Description: "None", Value: UnscheduledRemoveReasonSubType.None },
  { Description: "Fail On Fit", Value: UnscheduledRemoveReasonSubType.FailOnFit },
  { Description: "INOP", Value: UnscheduledRemoveReasonSubType.INOP },
  { Description: "Premature Failure", Value: UnscheduledRemoveReasonSubType.PrematureFailure },
];

export const GetRejectionQuarantinedRemoveReasonSubType = [
  { Description: "Part Received as Damaged", Value: RejectionQuarantinedRemoveReasonSubType.PartReceivedAsDamaged },
  {
    Description: "Typo Mistake in Documentation",
    Value: RejectionQuarantinedRemoveReasonSubType.TypoMistakeInDocumentation,
  },
  { Description: "TSN/CSN Issue", Value: RejectionQuarantinedRemoveReasonSubType.TsnCsnIssue },
  { Description: "Missing Page In Paperwork", Value: RejectionQuarantinedRemoveReasonSubType.MissingPageInPaperwork },
  { Description: "AD/SB Issue", Value: RejectionQuarantinedRemoveReasonSubType.AdSbIssue },
  { Description: "PN/SN Mismatch Discrepancy", Value: RejectionQuarantinedRemoveReasonSubType.PnSnMismatcDiscrepancy },
  {
    Description: "Life of the Part About to Expire",
    Value: RejectionQuarantinedRemoveReasonSubType.LifeOfThePartAboutToExpire,
  },
  { Description: "Other", Value: RejectionQuarantinedRemoveReasonSubType.Other },
];

export const GetPbhRemoveReasonSubType = removeReasonType => {
  if (removeReasonType === PbhRemoveReasonType.Scheduled) {
    return GetScheduledRemoveReasonSubType;
  } else if (removeReasonType === PbhRemoveReasonType.Unscheduled) {
    return GetUnscheduledRemoveReasonSubType;
  } else if (removeReasonType === PbhRemoveReasonType.RejectedQuarantinedPart) {
    return GetRejectionQuarantinedRemoveReasonSubType;
  }
};

export const GetRbhRemoveReasonSubType = removeReasonType => {
  if (removeReasonType === RbhRemoveReasonType.Scheduled) {
    return GetScheduledRemoveReasonSubType;
  } else if (removeReasonType === RbhRemoveReasonType.Unscheduled) {
    return GetUnscheduledRemoveReasonSubType;
  }
};
